import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import throttle from 'lodash/throttle';
import { Transition } from 'react-transition-group';
import compose from 'lodash/flowRight';
import { analyticService } from 'global/services';
import queryString from 'query-string';

import { CATEGORY_TITLES } from 'app/const/categories';

import { getAvailableLinksWithUrl, getAvailablePeriods } from 'app/utils/links';
import LINKS from 'app/const/links';

import Burger from 'assets/svg/burger.svg';
import { useRouterState } from 'app/hooks/useRouterState';
import { withLocaleContext } from 'app/containers/LocaleProvider';
import { withAvailableLinks } from 'app/containers/contexts/availableLinks.context';
import { withMenuDatesContext } from 'app/containers/contexts/menuDates.context';
import { withFiltersContext } from 'app/containers/contexts/filters.context/filters.context';
import { withSelectedFilters } from 'app/connect/connectToSelectedFilters';

import { Mobile, Desktop } from 'app/components/Responsive';
import Link, { LINK_TYPE_NAV } from 'app/components/Link';

import UI from 'app/components/ui';
import { useMenuPeriodsData } from 'app/hooks/accessors';
import {
    ADD_ITEMS_TO_CART_BY_ID_LIST,
    ADD_ITEMS_TO_CART_BY_SCHEMA,
} from 'app/graphql/network/basket/basketMutations';
import {
    gql, useFragment, useMutation, useReactiveVar,
} from '@apollo/client';
import { selectedPeriodVar } from 'app/apollo/reaction';
import { parseTags } from 'app/utils/basketSchema';
import { useHistory } from 'react-router';
import { onCompletedBillingMutation, useInitialBillingMutatation } from 'app/containers/BasketResolver';
import { URLUpdater } from 'global/utils';
import payment from 'app/graphql/network/payment';
import { CROSSED_PRICE_DISCOUNT_TYPE } from 'app/const/crossedPricesPromo';
import HeaderCategory from '../HeaderCategory';
import HeaderTags from '../HeaderTags';
import MobileSiteNav from '../MobileSiteNav';
import BasketButtonWrapper from '../BasketButtonWrapper';
import {
    MENU_DISH_DISCOUNT_CONDITIONS_FRAGMENT,
} from '../../../../components/MobileDish/MobileDishDescription/graphql/menuDishDiscountConditionsFragment.graphql';

import { MobileHeaderWithCategoriesSlider } from './MobileHeaderWithCategoriesSlider';
import { getDesktopHeaderLinksOptions } from './navigationStaticLinks';
import { locales } from './navigation.locales';

/* QUERIES AND MUTATIONS */

import styles from './navigation.scss';


const BURGER_SHOW_TIMEOUT = 300;

const { SPA_MENU } = LINKS;

const isMenuLinkActive = (match, location) => {
    if (!match) {
        const { pathname } = location;
        return pathname === '/';
    }
    const { url } = match;
    return url.includes(SPA_MENU.href);
};

const isProfile = (location) => location.pathname.includes('/profile');
const isAuthPage = (location) => location.pathname.includes('/auth');

function MobileHeaderSkeleton() {
    const classes = classNames({
        'burger-button': true,
        'is-close': true,
    });

    return (
        <div styleName="navigation-category">
            <div styleName="navigation-category__wrap">
                <button
                    styleName={classes}
                    type="button"
                    aria-label="Меню сайта"
                    onClick={() => { }}
                    disabled
                >
                    <Burger data-referral-menu-item="true" />
                </button>
                {/*  */}
                {/*  */}
                <div styleName="header-category__filter-button-container">
                    <UI.FiltersButton
                        onClick={() => { }}
                        disabled
                    />
                </div>
            </div>
        </div>
    );
}

// MobileHeaderSkeleton.propTypes = {
//     isNewHeaderRenderNeeded: PropTypes.bool,
//     isABTestFetched: PropTypes.string,
// };

class Navigation extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            showBestSetsTitle: true,
        };
        this.resolveBestSetsTitleStateThrottled = throttle(this.resolveBestSetsTitleState, 100);
    }

    componentDidMount() {
        this.resolveBestSetsTitleState();
        window.addEventListener('scroll', this.resolveBestSetsTitleStateThrottled);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.resolveBestSetsTitleStateThrottled);
    }

    resolveBestSetsTitleState = () => {
        const { match: { params: { deliveryId } } } = this.props;
        if (deliveryId) {
            this.setState({
                showBestSetsTitle: false,
            });
            return;
        }

        if (window.scrollY < 300) {
            this.setState({
                showBestSetsTitle: true,
            });
        } else {
            this.setState({
                showBestSetsTitle: false,
            });
        }
    };

    // eslint-disable-next-line class-methods-use-this
    renderActiveNavLink() {
        const { localeContext: { locale } } = this.props;
        const text = locales[locale].allDishes;

        return (
            <h1 styleName="nav__item-wrap">
                <Link
                    type={LINK_TYPE_NAV}
                    href={SPA_MENU.href}
                    activeClassName={styles.active}
                    styleName="nav__item"
                    isActive={isMenuLinkActive}
                >
                    {text}
                </Link>
            </h1>
        );
    }

    renderStaticLinks() {
        const {
            localeContext,
            filterQuery,
            onClickMobileNavigationButton,
            menuDatesContext,
            linksContext,
            filtBasketByType,
            history,
            isPromoCodeActivated,
            discountType,
        } = this.props;

        const allAvailableLinks = linksContext;

        const enabledDatesData = menuDatesContext?.state?.enabledDatesData;
        const periods = filterQuery?.menuFilter?.periods;

        if (!periods) return null;
        if (!enabledDatesData) return null;

        const { locale } = localeContext;

        const hideEvery = discountType === CROSSED_PRICE_DISCOUNT_TYPE && isPromoCodeActivated;
        const availablePeriods = getAvailablePeriods(periods);
        const specificLinks = getDesktopHeaderLinksOptions({ locale, showEvery: !hideEvery });

        const availableLinks = getAvailableLinksWithUrl({
            allAvailableLinks,
            specificLinks,
            availablePeriods,
            enabledDatesData,
        });

        const handleClickSetLink = (event, id, link) => {
            console.log(link);
            event.preventDefault();
            event.stopPropagation();
            filtBasketByType(id);
            analyticService.push({
                setName: id,
                eventName: 'Track_Click_Best_Set',
            });
        };

        return availableLinks.map(({ data }) => {
            const { Text, text, href } = data;

            const classes = classNames({
                nav__item: true,
            });

            return (
                <button
                    key={data.href}
                    styleName={classes}
                    type="button"
                    onClick={(event) => {
                        handleClickSetLink(event, data?.trackId, data.href);
                    }}
                >
                    {Text
                        ? <Text localeContext={localeContext} />
                        : text
                    }
                </button>
            );
        });
    }

    // extra link for new year, e.g.
    // renderExtraLink() {
    //     const { onClickMobileNavigationButton } = this.props;

    //     return (
    //         <a
    //             href="http://elementaree.ru/2020/"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             styleName="nav__item ny"
    //             onClick={onClickMobileNavigationButton}
    //         >
    //             <div styleName="ny-menu-item-img-wrap">
    //                 <div styleName="ny-menu-item-img-wrap-wrap">
    //                     <NYImg1 styleName="ny-menu-item-img" />
    //                     <NYImg2 styleName="ny-menu-item-img" />
    //                 </div>
    //             </div>
    //             <span styleName="text small">Рождество</span>
    //             <span styleName="text big">Меню на Рождество</span>
    //         </a>
    //     );
    // }

    renderNavLinks() {
        return (
            <div styleName="nav">
                {this.renderActiveNavLink()}
                {this.renderStaticLinks()}
                {/* {this.renderExtraLink()} */}
            </div>
        );
    }

    renderDesktopNavbar() {
        const {
            isNavigationHidden,
        } = this.props;

        return (
            <div styleName="navigation-navbar">
                {!isNavigationHidden && this.renderNavLinks()}
            </div>
        );
    }

    renderBurgerButton() {
        const {
            isMobileNavigationOpen,
            onClickMobileNavigationButton,
        } = this.props;

        const classes = classNames({
            'burger-button': true,
            'is-open': isMobileNavigationOpen,
            'is-close': !isMobileNavigationOpen,
        });
        return (
            <button
                styleName={classes}
                type="button"
                aria-label="Меню сайта"
                onClick={onClickMobileNavigationButton}
            >
                <Burger data-referral-menu-item="true" />
            </button>
        );
    }

    renderHeaderFilter(props) {
        const {
            location,
            selectedFilters: {
                selectedCategoryId,
            },
            onClickMobileFilters,
            showFilterChangedAnimation,
            mainDishesCountState,
            isSoldOutNotificationVisible,
            onClickCloseSoldOutNotification,

            setDishesUpdatingState,
            isCategoryChanging,

            isMobileNavigationOpen,

            updateBilling,
            selectedFilters: { selectedTags },
            localeContext: { locale },
        } = this.props;

        const { showBestSetsTitle } = this.state;
        const {
            menuDishesQuery: {
                allDishes,
                basketDishes,
            },
            hasDataForRenderDishes,
        } = props;

        if (!hasDataForRenderDishes) {
            return (
                <div styleName="navigation-category">
                    {this.renderBurgerButton()}
                </div>
            );
        }

        const categoryTitle = CATEGORY_TITLES[locale][selectedCategoryId];

        const headerCategoryProps = {
            selectedTags,
            showBestSetsTitle,
            categoryTitle,
            showFilterChangedAnimation,
            mainDishesCountState,
            isSoldOutNotificationVisible,
            onClickCloseSoldOutNotification,

            setDishesUpdatingState,
            isCategoryChanging,
        };

        const categoryWrapClasses = classNames({
            'navigation-category__wrap': true,
            'is-hidden': isMobileNavigationOpen,
        });

        const tagsClasses = classNames({
            'navigation-tags': true,
            'is-hidden': isMobileNavigationOpen,
        });

        return (
            <>
                <div styleName="navigation-category">
                    {this.renderBurgerButton()}
                    <div styleName={categoryWrapClasses}>
                        <HeaderCategory
                            onClickFilter={onClickMobileFilters}
                            {...headerCategoryProps}
                            locale={locale}
                        />
                    </div>
                </div>
                <div styleName={tagsClasses}>
                    <HeaderTags />
                </div>
            </>
        );
    }

    renderMobileMenuHeader() {
        const {
            isMenuLocation,
            mainDishesCountState,
            onClickMobileNavigationButton,
            onClickMobileFilters,
        } = this.props;

        const isSkeletonShown = isMenuLocation && mainDishesCountState === 'loading';

        if (isSkeletonShown) {
            return (
                <MobileHeaderSkeleton />
            );
        }
        return (
            <MobileHeaderWithCategoriesSlider
                onClickMobileNavigationButton={onClickMobileNavigationButton}
                onClickFilters={onClickMobileFilters}
            />
        );
    }

    renderMobileNav() {
        const {
            history,
            isMobileNavigationOpen,
            onClickMobileNavigationButton,
            onClickQuit,
        } = this.props;

        return (
            <Transition
                mountOnEnter
                unmountOnExit
                timeout={BURGER_SHOW_TIMEOUT}
                in={isMobileNavigationOpen}
            >
                {(transitionState) => (
                    <MobileSiteNav
                        history={history}
                        transitionState={transitionState}
                        onClickNavLink={onClickMobileNavigationButton}
                        onClickQuit={onClickQuit}
                    />
                )}
            </Transition>
        );
    }

    render() {
        const {
            localeContext,
            onClickBasketButton,
            location,
        } = this.props;

        // TODO: BR-1084 Header is here ;)
        return (
            <>
                <Mobile>
                    {this.renderMobileNav()}
                    {this.renderMobileMenuHeader()}
                </Mobile>
                {!isProfile(location) && (
                    <Desktop>
                        <div styleName="navigation">
                            <div styleName="navigation-wrapper">
                                {this.renderDesktopNavbar()}
                                <BasketButtonWrapper
                                    localeContext={localeContext}
                                    location={location}
                                    onClickBasketButton={onClickBasketButton}
                                />
                            </div>
                        </div>
                    </Desktop>
                )}
            </>
        );
    }
}


Navigation.propTypes = {
    localeContext: PropTypes.shape({
        locale: PropTypes.string.isRequired,
    }).isRequired,

    menuDatesContext: PropTypes.shape({
        state: PropTypes.shape({
            enabledDatesData: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }).isRequired,

    linksContext: PropTypes.shape({}).isRequired,

    isMenuLocation: PropTypes.bool.isRequired,
    onClickBasketButton: PropTypes.func.isRequired,

    filterQuery: PropTypes.shape({
        loading: PropTypes.bool,
        error: PropTypes.shape({}),
        menuFilter: PropTypes.shape({
            periods: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }).isRequired,
    selectedFilters: PropTypes.shape({
        selectedPeriod: PropTypes.string,
        selectedCategoryId: PropTypes.string,
        selectedTags: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
    onClickMobileFilters: PropTypes.func.isRequired,

    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            deliveryId: PropTypes.string,
        }).isRequired,
    }).isRequired,
    history: PropTypes.shape({}).isRequired,
    onClickQuit: PropTypes.func.isRequired,
    isMobileNavigationOpen: PropTypes.bool.isRequired,
    onClickMobileNavigationButton: PropTypes.func.isRequired,
    onClickBack: PropTypes.func.isRequired,
    showFilterChangedAnimation: PropTypes.bool.isRequired,
    mainDishesCountState: PropTypes.string.isRequired,
    onClickCloseSoldOutNotification: PropTypes.func.isRequired,
    setDishesUpdatingState: PropTypes.func.isRequired,
    isCategoryChanging: PropTypes.bool.isRequired,
    updateBilling: PropTypes.func.isRequired,
};


const NAV_BILLING_MUTATION = gql`
    mutation NAV_BILLING_MUTATION(
        $promocode: String,
        $period: String!,
        $payment_method: paymentMethod,
        $phone: String,
    ) {
        billing(
            promocode: $promocode,
            period: $period,
            payment_method: $payment_method,
            phone: $phone,
        ) {
            promocode
            payment_method
            isNewbie
        }
    }
`;

const NavigationDataAccessContainer = (props) => {
    const [routerState] = useRouterState();
    const { history } = routerState;
    const period = useReactiveVar(selectedPeriodVar);
    const { location: { search } } = window;
    const params = new URLSearchParams(search);

    const filterQuery = {
        menuFilter: useMenuPeriodsData(),
    };


    const [
        addItemsToCartByIdList,
        { loading: isAddItemsToCartByIdListLoading },
    ] = useMutation(ADD_ITEMS_TO_CART_BY_ID_LIST, {
        context: {
            message: 'app:mutate:BasketResolver',
        },
    });
    const [
        addItemsToCartBySchema,
        { loading: isAddItemsToCartBySchemaLoading },
    ] = useMutation(ADD_ITEMS_TO_CART_BY_SCHEMA, {
        context: {
            message: 'app:mutate:BasketResolver',
        },
    });

    const { data: { isPromoCodeActivated, discountType } } = useFragment({
        fragment: MENU_DISH_DISCOUNT_CONDITIONS_FRAGMENT,
        from: {
            __ref: `DiscountConditions:${period}`,
        },
    });


    const [mutateBilling] = useMutation(NAV_BILLING_MUTATION, {
        onCompleted: (data) => { onCompletedBillingMutation(data); },
    });

    const filtBasketByType = (set) => {
        if (set === 'trial') {
            addItemsToCartByIdList({
                variables: {
                    period,
                    dishes: [
                        '1378',
                        '2241',
                        '2929',
                        '4809',
                        '4908',
                    ],
                },
            }).then(() => {
                params.delete('cm');
                params.delete('menu');
                params.set('dishes', '1378.2241.2929.4809.4908');
                params.set('payment', 'online');
                history.push(`/basket/?${params.toString()}`);
            });
        } else if (set === 'weekly') {
            const tags = parseTags(window.location);
            addItemsToCartBySchema({
                variables: {
                    period,
                    menuType: 'everyday',
                    tags: tags || [],
                    schema: [{ category_id: 3, count: 10 }],
                },
                onCompleted: () => { },
            }).then(() => {
                params.delete('dishes');
                params.set('cm', '10');
                params.set('menu', 'everyday');
                params.set('payment', 'recurrent');
                history.push(`/basket/?${params.toString()}`);
            });
        }
    };

    const filtBasketByTypewithBilling = (set) => {
        const queryParams = queryString.parse(window.location.search);
        const promocodeFromUrl = queryParams?.promo_code;
        let paymentMethod;
        switch (set) {
            case 'trial':
                paymentMethod = 'online';
                break;
            case 'weekly':
                paymentMethod = 'recurrent';
                break;
            default:
                break;
        }
        mutateBilling({
            variables: {
                promocode: set === 'trial' ? (promocodeFromUrl || '22try5x2') : '',
                payment_method: paymentMethod,
                period,
            },
        }).then(() => { filtBasketByType(set); });
    };

    return (
        <Navigation
            {...props}
            {...routerState}
            isPromoCodeActivated={isPromoCodeActivated}
            discountType={discountType}
            filterQuery={filterQuery}
            filtBasketByType={filtBasketByTypewithBilling}
            history={history}
        />
    );
};


export default compose(
    withFiltersContext,
    withSelectedFilters,

    withAvailableLinks,
    withLocaleContext,
    withMenuDatesContext,
)(NavigationDataAccessContainer);
